import React from 'react';

import './Home.scoped.scss';

import Header from '../../components/header/Header'
import LocationFetcher from '../../components/utils/LocationFetcher';
import MapComponent from '../../components/map/Map';

const Home = () => {
    return (
        <div>
            <Header></Header>
            <LocationFetcher>
                <MapComponent/>
            </LocationFetcher>
        </div>
    );
}
    
    

export default Home;